<template>
    <div v-if="caixa">
        <v-toolbar flat dense color="primary" app  dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Caixa Pacpon</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click.stop="load">
                <v-icon>autorenew</v-icon>
            </v-btn>

            <v-tabs
                    color="primary"
                    slot="extension"
                    grow
                    fixed-tabs
                    v-model="tab"
            >
                <v-tabs-slider color="yellow"></v-tabs-slider>

                <v-tab :key="'dados'" class="white--text">
                    <v-icon class="white--text">description</v-icon> &nbsp; <small>DADOS</small>
                </v-tab>

                <v-tab :key="'user'" class="white--text">
                    <v-icon class="white--text">person</v-icon> &nbsp; <small>CLIENTES</small>
                </v-tab>

                <v-tab :key="'map'" class="white--text">
                    <v-icon class="white--text">map</v-icon> &nbsp; <small>MAPA</small>
                </v-tab>

            </v-tabs>
        </v-toolbar>

            <v-tabs-items v-model="tab">

                <v-tab-item :key="'dados'">
                    <v-container
                            fluid
                            grid-list-lg
                    >

                        <v-layout justify-center>
                            <v-flex xs12 sm8>
                                <v-card>
                                    <v-card-title v-if="caixa.info.online"  class="green darken-1">
                                        <span class="headline white--text">
                                            <b>Caixa Online</b><br/><small>{{caixa.nome}}</small>
                                        </span>
                                    </v-card-title>

                                    <v-card-title v-else class="red darken-1">
                                        <span class="headline white--text">
                                            <b>Caixa Offline</b><br/><small>{{caixa.nome}}</small>
                                        </span>
                                    </v-card-title>

                                    <v-list>
                                        <v-list-tile v-if="caixa.porta_pon">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>PORTA PON</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.porta_pon.nome}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.fibra">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>FIBRA</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.fibra.nome}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>VLAN</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.vlan}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>ONU MAC</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.onu_mac}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.info">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>RX / TX</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">
                                                    {{caixa.info.onu.rx_power.value}} {{caixa.info.onu.rx_power.unit}}
                                                    /
                                                    {{caixa.info.onu.tx_power.value}} {{caixa.info.onu.tx_power.unit}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.info">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>TEMPERATURA</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.info.onu.temperature.value}} {{caixa.info.onu.temperature.unit}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                    </v-list>

                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-flex xs12 sm8>
                                <v-card>

                                    <v-list class="blue lighten-1 white--text">
                                        <v-list-tile>
                                            <v-list-tile-content >
                                                <span>{{caixa.obs}}</span>
                                                <v-divider></v-divider>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-tab-item>

                <v-tab-item :key="'user'">
                    <clientes-na-caixa :id="caixa._id" />
                </v-tab-item>

                <v-tab-item :key="'map'">
                    <map-caixa :lat="caixa.place[1]" :lng="caixa.place[0]"/>
                </v-tab-item>

            </v-tabs-items>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import MapCaixa from "../../components/caixa/MapCaixa"
    import ClientesNaCaixa from "../../components/caixa/ClientesNaCaixa"
    export default {
        name: "ViewCaixa",
        components: {
            MapCaixa, ClientesNaCaixa
        },
        data () {
            return {
                tab: 0,
                clipped: true,
                caixa: null
            };
        },
        beforeMount () {
            this.load();
        },
        methods: {
            goBack: function () {
                this.$router.go(-1);
            },
            load () {
                Caixas
                    .caixaPacPon(this.$route.params.id)
                    .then(ordens => {
                        this.caixa = ordens.data
                    })
                    .catch((err) => console.error(err))
            }
        }
    };
</script>

<style scoped>

</style>
